import { DATASET_CATEGORIES } from '../generic/filterBestDataset';
import { MarkerItem } from '../typings/home';
import { ShoppingItem } from '../typings/shopping';
import { DatasetRecord } from './ResultPanel/Store/dataTypes';

export const pointIsInCart = (
  markerPoint: MarkerItem,
  shoppingItems: { [key: string]: { [key: string]: ShoppingItem } }
) => {
  let pointIsInCard = false;
  if (markerPoint) {
    const name = markerPoint.label;
    const pointWithSameNameIsInCard = markerPoint
      ? Object.keys(shoppingItems).includes(name)
      : false;
    if (pointWithSameNameIsInCard) {
      const itemsPerPoint = shoppingItems[name];
      const categories = Object.keys(itemsPerPoint);
      const firstCategory = itemsPerPoint[categories[0]];
      // Take also coordinates into account to allow editing of points with same name from previous sessions
      pointIsInCard =
        markerPoint.coordinates.join() ===
        firstCategory.location.replace(' ', '');
    }
  }
  return pointIsInCard;
};

export const getCategoryPostfix = (category: string) => {
  let postfixCategory = category;
  switch (category) {
    case DATASET_CATEGORIES.ATMOSPHERE:
      postfixCategory = ' (Wind, pressure, etc.)';
      break;
    case DATASET_CATEGORIES.OCEAN:
      postfixCategory = ' (Water Level, Current, etc.)';
      break;
    case DATASET_CATEGORIES.WAVES:
      postfixCategory = ' (total, wind-sea and swell)';
      break;
    default:
      break;
  }
  return postfixCategory;
};

export function extractMetadata(data: Record<string, DatasetRecord>) {
  if (data) {
    return Object.values(data).map((item) => item.metadata)
  }
}